<app-page
  [flush]="true"
  pageTitle="Paketi"
  pageDescription="Upravljanje paketima i pregled iskorišćenosti"
  [thirdActionLabel]="showHeaderAction() ? 'Kupite paket' : ''"
  (onHandleThirdAction)="goToOffer()"
>
  <app-cube-01 thirdIcon stroke="white" width="18px" height="18px"></app-cube-01>

  @if (showOnboardingBanner()) {
    <div class="banner banner--dark banner--dismissible mt-4">
      <div class="flex align-items-center gap-3 banner__content">
        <div class="banner__icon">
          <app-cube-01 stroke="#F0F2F5" width="20px" height="20px"></app-cube-01>
        </div>
        <div class="flex flex-column gap-1">
          <div class="text-sm-semibold banner__title">Sledeći korak: kupovina paketa</div>
          <div class="text-sm-regular banner__sub">
            Zakazivanje termina biće dostupno nakon kupovine paketa
          </div>
        </div>
      </div>
      <svg class="banner__arc" viewBox="0 0 280 140" fill="none" aria-hidden="true">
        <circle cx="240" cy="70" r="160" stroke="rgba(255,255,255,0.12)" stroke-width="48"/>
        <circle cx="240" cy="70" r="96" stroke="rgba(255,255,255,0.08)" stroke-width="32"/>
      </svg>
      <div class="banner__actions flex align-items-center gap-2">
        <app-button
          [btnSize]="ButtonSize.MD"
          [btnSeverity]="ButtonSeverity.SECONDARY"
          (btnClicked)="goToOffer()"
        >
          <app-cube-01 stroke="#181D27" width="20px" height="20px"></app-cube-01>
          <span class="text-sm-semibold text-gray-900">Kupite paket</span>
        </app-button>
      </div>
      <button class="banner__close" (click)="dismissOnboarding()" aria-label="Zatvori">
        <app-x-close stroke="#FFFFFF" width="14" height="14"></app-x-close>
      </button>
    </div>
  } @else if (showProcessingBanner()) {
    <div class="banner banner--dark mt-4">
      <div class="flex align-items-center gap-3 banner__content">
        <div class="banner__icon">
          <app-clock-fast-forward stroke="#F79009" width="20px" height="20px"></app-clock-fast-forward>
        </div>
        <div class="flex flex-column gap-1">
          <div class="text-sm-semibold banner__title">Vaša porudžbina je u obradi.</div>
          <div class="text-sm-regular banner__sub">
            Status možete proveriti u tabu &ldquo;U obradi&rdquo; u okviru sekcije Svi paketi.
          </div>
        </div>
      </div>
      <svg class="banner__arc" viewBox="0 0 280 140" fill="none" aria-hidden="true">
        <circle cx="240" cy="70" r="160" stroke="rgba(255,255,255,0.12)" stroke-width="48"/>
        <circle cx="240" cy="70" r="96" stroke="rgba(255,255,255,0.08)" stroke-width="32"/>
      </svg>
    </div>
  }

  <!-- Status paketa card -->
  <div class="status-card mt-card">
    <div class="flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-2">
      <div class="text-lg-semibold text-gray-900">Status paketa</div>
      @if (pendingCount() > 0) {
        <div class="pending-badge flex align-items-center gap-1-5">
          <span class="pending-dot"></span>
          <span class="text-sm-semibold text-gray-700">
            {{ pendingCount() }} {{ pendingCount() === 1 ? 'paket' : 'paketa' }} u obradi
          </span>
        </div>
      }
    </div>

    <div class="stats-grid mt-card">
      <div class="stat-tile">
        <div class="stat-tile__icon">
          <app-hourglas-03 stroke="#414651" width="18px" height="18px"></app-hourglas-03>
        </div>
        <div class="ml-3 flex flex-column gap-1">
          <div class="text-sm-semibold text-gray-600">Preostalo</div>
          @if (statsLoading()) {
            <p-skeleton width="3rem" height="1.75rem"></p-skeleton>
          } @else if (hasNoPackages()) {
            <div class="stat-tile__value">
              <span class="display-sm-semibold text-gray-900">-</span>
            </div>
          } @else {
            <div class="stat-tile__value">
              <span class="display-sm-semibold text-gray-900">{{ stats()?.availableHours ?? 0 }}</span>
              <span class="display-sm-semibold text-gray-400">&nbsp;h</span>
            </div>
          }
        </div>
      </div>

      <div class="stat-tile">
        <div class="stat-tile__icon">
          <app-check-circle stroke="#414651" width="18px" height="18px"></app-check-circle>
        </div>
        <div class="ml-3 flex flex-column gap-1">
          <div class="text-sm-semibold  text-gray-600">Iskorišćeno</div>
          @if (statsLoading()) {
            <p-skeleton width="3rem" height="1.75rem"></p-skeleton>
          } @else if (hasNoPackages()) {
            <div class="stat-tile__value">
              <span class="display-sm-semibold text-gray-900">-</span>
            </div>
          } @else {
            <div class="stat-tile__value">
              <span class="display-sm-semibold text-gray-900">{{ stats()?.usedHours ?? 0 }}</span>
              <span class="display-sm-semibold text-gray-400">&nbsp;h</span>
            </div>
          }
        </div>
      </div>

      <div class="stat-tile">
        <div class="stat-tile__icon">
          <app-cube-01 stroke="#414651" width="18px" height="18px"></app-cube-01>
        </div>
        <div class="ml-3 flex flex-column gap-1">
          <div class="text-sm-semibold  text-gray-600">Ukupno</div>
          @if (statsLoading()) {
            <p-skeleton width="3rem" height="1.75rem"></p-skeleton>
          } @else if (hasNoPackages()) {
            <div class="stat-tile__value">
              <span class="display-sm-semibold text-gray-900">-</span>
            </div>
          } @else {
            <div class="stat-tile__value">
              <span class="display-sm-semibold text-gray-900">{{ stats()?.totalHours ?? 0 }}</span>
              <span class="display-sm-semibold text-gray-400">&nbsp;h</span>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="mt-4">
      <div class="flex align-items-center justify-content-between mb-2">
        <span class="text-sm-semibold text-gray-600">Iskorišćenost</span>
        <span class="text-sm-bold text-gray-900">{{ stats()?.usedPercentage ?? 0 }}%</span>
      </div>
      <div class="usage-bar-track">
        <div class="usage-bar-fill" [style.width.%]="stats()?.usedPercentage ?? 0"></div>
      </div>
    </div>
  </div>

  <!-- Svi paketi -->
  <div class="mt-4">
    <div class="text-md-semibold text-gray-900 mb-3">Svi paketi</div>

    <p-tabs class="transparent mb-3-5" [value]="activeTab()" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">
          <div class="flex align-items-center gap-2">
            <app-check-circle
              [stroke]="activeTab() === 0 ? '#181D27' : '#7E838F'"
              width="14px"
              height="14px"
            ></app-check-circle>
            <span class="text-sm-semibold">Aktivni</span>
          </div>
        </p-tab>
        <p-tab [value]="1">
          <div class="flex align-items-center gap-2">
            <app-clock-rewind
              [stroke]="activeTab() === 1 ? '#181D27' : '#7E838F'"
              width="14px"
              height="14px"
            ></app-clock-rewind>
            <span class="text-sm-semibold">Istorija</span>
          </div>
        </p-tab>
        <p-tab [value]="2">
          <div class="flex align-items-center gap-2">
            <app-loading-01
              [stroke]="activeTab() === 2 ? '#181D27' : '#7E838F'"
              width="14px"
              height="14px"
            ></app-loading-01>
            <span class="text-sm-semibold">U obradi</span>
          </div>
        </p-tab>
      </p-tablist>
    </p-tabs>

    <app-data-table
      class="mt-3-5"
      [value]="packages"
      [first]="first"
      [rows]="paginatedData.pageSize!"
      [totalRecords]="paginatedData.totalCount!"
      [isLoading]="isLoading"
      [hasPreviousPage]="!!paginatedData.hasPreviousPage"
      [hasNextPage]="!!paginatedData.hasNextPage"
      (lazyLoad)="loadLazy($event)"
      (prevPage)="prev()"
      (nextPage)="next()"
    >
      <ng-template #tableHeader>
        <tr>
          <th><div class="text-xs-semibold text-gray-400 pt-2-5">PAKET</div></th>
          <th><div class="text-xs-semibold text-gray-400 header-cell">STATUS</div></th>

          @switch (activeTab()) {
            @case (0) {
              <th><div class="text-xs-semibold text-gray-400 header-cell">PREOSTALO SATI</div></th>
              <th><div class="text-xs-semibold text-gray-400 header-cell">DATUM AKTIVACIJE</div></th>
              <th><div class="text-xs-semibold text-gray-400 header-cell">DATUM ISTEKA</div></th>
            }
            @case (1) {
              <th><div class="text-xs-semibold text-gray-400 header-cell">PREOSTALO SATI</div></th>
              <th><div class="text-xs-semibold text-gray-400 header-cell">DATUM AKTIVACIJE</div></th>
              <th><div class="text-xs-semibold text-gray-400 header-cell">DATUM ISTEKA</div></th>
            }
            @case (2) {
              <th><div class="text-xs-semibold text-gray-400 header-cell">DATUM ZAHTEVA</div></th>
              <th><div class="text-xs-semibold text-gray-400 header-cell">SLEDEĆI KORAK</div></th>
            }
          }
        </tr>
      </ng-template>

      <ng-template #tableBody let-pkg>
        <tr>
          <td>
            <div class="flex align-items-center gap-3">
              <div class="row-icon">
                <app-cube-01 stroke="#ADB0B8" width="16px" height="16px"></app-cube-01>
              </div>
              <span class="text-sm-medium text-gray-900">{{ pkg.packageName }}</span>
            </div>
          </td>
          <td>
            @if (activeTab() === 1) {
              <p-chip
                [label]="getIstorijaChipLabel(pkg)"
                [class]="getIstorijaChipClass(pkg)"
              ></p-chip>
            } @else {
              <p-chip
                [label]="pkg.status?.description ?? ''"
                [class]="getStatusChipClass(pkg.status)"
              ></p-chip>
            }
          </td>

          @switch (activeTab()) {
            @case (0) {
              <td>
                <div class="flex align-items-center gap-3">
                  <div class="progress-bar-track">
                    <div
                      class="progress-bar-fill"
                      [class.progress-bar-fill--red]="isBarRed(pkg)"
                      [style.width.%]="getBarPercent(pkg)"
                    ></div>
                  </div>
                  <span class="hours-text">
                    <span class="text-sm-semibold text-gray-900">{{ getAvailableHours(pkg) }}</span>
                    <span class="text-sm-medium text-gray-500"> / {{ getTotalHours(pkg) }}</span>
                  </span>
                </div>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validFrom ? getDateFormatedSr(pkg.validFrom) : '-' }}
                </span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validTo ? getDateFormatedSr(pkg.validTo) : '-' }}
                </span>
              </td>
            }
            @case (1) {
              <td>
                <span class="text-sm-medium text-gray-900">{{ getAvailableHours(pkg) }}</span>
                <span class="text-sm-medium text-gray-500"> / {{ getTotalHours(pkg) }}</span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validFrom ? getDateFormatedSr(pkg.validFrom) : '-' }}
                </span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validTo ? getDateFormatedSr(pkg.validTo) : '-' }}
                </span>
              </td>
            }
            @case (2) {
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.createdOn ? getDateFormatedSrWithTime(pkg.createdOn) : '-' }}
                </span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">{{ getNextStepLabel(pkg) }}</span>
              </td>
            }
          }
        </tr>
      </ng-template>

      <ng-template #tableEmpty>
        <tr>
          <td [attr.colspan]="activeTab() === 2 ? 4 : 5">
            <div class="empty-state flex flex-column align-items-center justify-content-center gap-3 py-5">
              <div class="empty-state__icon">
                <app-info-circle stroke="#ADB0B8" width="20px" height="20px"></app-info-circle>
              </div>
              @switch (activeTab()) {
                @case (0) {
                  <div class="text-md-semibold text-gray-900">Nemate aktivne pakete</div>
                  <div class="text-sm-regular text-gray-600">
                    Ovde će se prikazati vaši aktivni paketi.
                  </div>
                  <app-button
                    class="mt-2"
                    [btnSize]="ButtonSize.MD"
                    [btnSeverity]="ButtonSeverity.PRIMARY"
                    (btnClicked)="goToOffer()"
                  >
                    <app-cube-01 stroke="white" width="20px" height="20px"></app-cube-01>
                    <span class="text-sm-semibold text-white">Kupite paket</span>
                  </app-button>
                }
                @case (1) {
                  <div class="text-md-semibold text-gray-900">Nema prethodnih paketa</div>
                  <div class="text-sm-regular text-gray-600">
                    Ovde će se prikazati paketi koji su istekli ili su u potpunosti iskorišćeni.
                  </div>
                }
                @case (2) {
                  <div class="text-md-semibold text-gray-900">Nema paketa u obradi</div>
                  <div class="text-sm-regular text-gray-600">
                    Ovde će se prikazati paketi koji čekaju potvrdu ili uplatu.
                  </div>
                }
              }
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template #tableLoading>
        @for (r of [1,2,3,4]; track r) {
          <tr>
            <td>
              <div class="flex align-items-center gap-2">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
                <p-skeleton width="7rem"></p-skeleton>
              </div>
            </td>
            <td><p-skeleton width="6rem" height="1.375rem"></p-skeleton></td>
            <td><p-skeleton width="9rem"></p-skeleton></td>
            <td><p-skeleton width="8rem"></p-skeleton></td>
            @if (activeTab() !== 2) {
              <td><p-skeleton width="6rem"></p-skeleton></td>
            }
          </tr>
        }
      </ng-template>
    </app-data-table>
  </div>
</app-page>
